<template>
  <div>
    <b-button
      v-b-tooltip.hover.v-dark
      v-b-modal.modal-checkout
      variant="gradient-primary"
      class="btn-icon"
      title="Generar Pago"
    >
      <feather-icon icon="FileTextIcon" />
    </b-button>
    <b-button
      v-b-tooltip.hover.v-dark
      v-b-modal.modal-contract-account
      variant="gradient-info"
      class="btn-icon"
      title="Estado de Cuenta"
    >
      <feather-icon icon="CreditCardIcon" />
    </b-button>

    <b-modal
      id="modal-checkout"
      ref="modal-checkout"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      :title="`Ingresar Pago ${data.codigo} - ${data.apenom}`"
    >
      <checkout
        :contract="data"
        :idcontrato="data.idcontrato"
      />
    </b-modal>

    <b-modal
      id="modal-contract-account"
      ref="modal-contract-account"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      size="xl"
      ignore-enforce-focus-selector=".swal2-container, .swal2-center"
      :title="`Estado Cuenta ${data.codigo} - ${data.apenom}`"
    >
      <contract-account-status :data="data" />
    </b-modal>
  </div>
</template>

<script>
import { BButton, VBTooltip } from "bootstrap-vue"
import Checkout from "@/views/home/Checkout.vue"
import ContractAccountStatus from "./ContractAccountStatus.vue"

export default {
  components: {
    BButton,
    ContractAccountStatus,
    Checkout,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    reload() {
      this.$root.$emit("bv::hide::modal", "modal-discount")
      this.$emit("reload")
    },
  },
}
</script>

<style></style>
